import React, {
  cloneElement,
  useEffect,
  useState,
  useCallback
} from 'react'
import { connect } from 'react-redux'
import {
  addPartnumPrimaryBin,
  addPartnumSecondaryBin,
  deletePartnum,
  deleteSecondaryBin,
  getPartnumData,
  updatePrimaryBin,
  updateSecondCount,
  updateVarianceCheckingStatus,
} from '../../api'
import OrderInfoHeader from '../../components/OrderInfoHeader'
import { fetchPrintData, getPartsAction } from '../../store/actions'
import { sortText } from '../../utils/sortHelper'
import BaseTable from '../BaseTable'
import AddNewBinButton from './AddNewBinButton'
import AddNewBinPartModal from './AddNewBinPartModal'
import { validateAddBin } from './validateAddBin'
import BinNameDeletable from './BinNameDeletable'
import CurrentCount from './CurrentCount'
import CurrentCountEditable from './CurrentCountEditable'
import './index.css'
import PartNameDeletable from './PartNameDeletable'
import UpdateCurrentCountModal from './UpdateCurrentCountModal'
import CurentCountBins from "./CurrentCountBins";


const getName = employee => `${employee.firstName} ${employee.lastName}`

const convertPartnumData = (data, employeeMap) => {
  return data.data.reduce((r, part) => {
    let secondaryBins = []
    let totalScanCount = 0
    let totalCurrentCount = 0

    // NEW: Look up names for the primary/parent row summary
    const primaryBinAssignedUser = employeeMap[part.primaryBinAssignedUserUUID]
    const primaryBinInputUser = employeeMap[part.primaryBinInputUserUUID]

    if (part.secondaryBins) {
      secondaryBins = Object.keys(part.secondaryBins).map(binName => {
        const bin = part.secondaryBins[binName]
        const assignedUser = employeeMap[bin.assignedUserUUID]
        const inputUser = employeeMap[bin.inputUserUUID]
        totalScanCount += bin.firstCount
        totalCurrentCount += bin.secondCount

        return {
          primaryPartnum: part.partnum,
          binName,
          binType: 'secondary',
          scanCount: bin.firstCount,
          currentCount: bin.secondCount,
          // Map UUID to Name string for child rows
          assignedUser: assignedUser ? getName(assignedUser) : '--',
          inputUser: inputUser ? getName(inputUser) : '--',
          binCount: bin.firstCount,
          id: `${part.partnum}-${binName}`,
        }
      })
    }

    const newPart = {
      ...part,
      binCount: part.secondaryBins ? Object.keys(part.secondaryBins).length + 1 : 1,
      dmsCount: part.overallCountOnFile,
      scanCount: totalScanCount + part.primaryBinFirstCount,
      currentCount: totalCurrentCount + part.primaryBinSecondCount,
      // NEW: Assign names to the parent object so the summary row sees them
      assignedUser: primaryBinAssignedUser ? getName(primaryBinAssignedUser) : '--',
      inputUser: primaryBinInputUser ? getName(primaryBinInputUser) : '--',
      bins: [
        {
          primaryPartnum: part.partnum,
          binName: part.primaryBin,
          binType: 'primary',
          scanCount: part.primaryBinFirstCount,
          currentCount: part.primaryBinSecondCount,
          assignedUser: primaryBinAssignedUser ? getName(primaryBinAssignedUser) : '--',
          inputUser: primaryBinInputUser ? getName(primaryBinInputUser) : '--',
          id: `${part.partnum}-${part.primaryBin}`,
        },
        ...secondaryBins,
      ],
    }
    r.push(newPart)
    return r
  }, [])
}

const OrderInfo = (props) => {
  const [parts, setParts] = useState([]);
  const [filteredParts, setFilteredParts] = useState([]);
  const [partsSort, setPartsSort] = useState({ isDesc: false, prop: '' });
  const [countingMode, setCountingMode] = useState('Parts');
  const [checked, isChecked] = useState(false);
  const [updateCurrentCountModal, setUpdateCurrentCountModal] = useState(null);
  const [updateCurrentCountError, setUpdateCurrentCountError] = useState('');
  const [
    updateCurrentCountModalButtonDisabled,
    setUpdateCurrentCountModalButtonDisabled,
  ] = useState(false)
  const [addItemModal, setAddItemModal] = useState(null)
  const [addItemError, setAddItemError] = useState('')
  const [addItemModalButtonDisabled, setAddItemModalButtonDisabled] = useState(false)
  const [actionsDisabled, setActionsDisabled] = useState(false)
  const [searchFilter, setSearchFilter] = useState('')
  const [tableBins, setTableBins] = useState([])
  const [checkedRows, setCheckedRows] = useState({});
  const [acceptedParts, setAcceptedParts] = useState(null)
  const [notNullablePartsBins, setNotNullablePartsBins] = useState([]);

  const dataForBins = {};

  useEffect(() => {
    !props.parts.length && props.getPartsAction(props.order.id);
  }, [props.order.id]);


  useEffect(() => {
    parts.forEach(({ bins, ...part }) => {
      bins.forEach((bin) => {
        if (!dataForBins[bin.binName]) {
          dataForBins[bin.binName] = { ...bin, parts: [], dmsCount: 0, unitPrice: 0, scanCount: 0, currentCount: 0, assignedUser: '--', inputUser: '--' }
        }
        dataForBins[bin.binName].parts.push(part);
        dataForBins[bin.binName].dmsCount += part.dmsCount;
        dataForBins[bin.binName].scanCount += part.scanCount;
        dataForBins[bin.binName].unitPrice += part.unitPrice;
        dataForBins[bin.binName].currentCount += part.currentCount;

        dataForBins[bin.binName].assignedUser = bin.assignedUser;
        dataForBins[bin.binName].inputUser = bin.inputUser;

      })
    })
    setTableBins(Object.values(dataForBins))
  }, [parts])


  useEffect(() => {
    (async () => {
      try {
        setActionsDisabled(true)
        const { data } = await getPartnumData(props.order.id)
        data.data.forEach(item => {
          if (item.primaryBinSecondCount !== null) {
            setNotNullablePartsBins(prevState => {
              return [...prevState, item.partnum, item.primaryBin]
            })
          }
        })
        setParts(convertPartnumData(data, props.employeeMap))
      } catch (error) {
        console.error('Something went wrong')
      } finally {
        setActionsDisabled(false)
      }
    })()
  }, [props.order, props.render, props.newRun])

  useEffect(() => {
    if (!parts.length) {
      return
    }
    if (!searchFilter) {
      return setFilteredParts(null)
    }
    setFilteredParts(parts.filter(part => {
      const lowerCaseTerm = searchFilter.toLowerCase()
      const [type, term] = lowerCaseTerm.split(': ')
      if (type === 'bin') {
        return part.bins.find((bin) => bin.binName.toLowerCase().indexOf(term) + 1)
      } else if (type === 'part') {
        return part.partnum.toLowerCase().indexOf(term) + 1
      } else {
        return false
      }
    }))
  }, [parts, searchFilter])


  useEffect(() => {
    (async () => {
      try {
        await props.fetchPrintData(parts)
      } catch (error) {
        console.error('Something went wrong')
      }
    })()
  }, [])


  const addSecondaryBin = async ({ partNumber, bin, count }) => {
    await addPartnumSecondaryBin(props.order.id, partNumber, bin, count)
    const newParts = parts.map(part => {
      if (part.partnum === partNumber) {
        return {
          ...part,
          binCount: +part.binCount + 1,
          scanCount: +part.scanCount + +count,
          bins: [
            ...part.bins,
            {
              primaryPartnum: partNumber,
              binName: bin,
              binType: 'secondary',
              scanCount: count,
              currentCount: 0,
              assignedUser: '--',
              inputUser: '--',
              id: `${partNumber}-${bin}`,
            },
          ],
        }
      } else {
        return part
      }
    })
    setParts(newParts)
  }

  const addPrimaryBin = async ({ partNumber, bin, count }) => {
    await addPartnumPrimaryBin(props.order.id, partNumber, bin, count, 0)
    const newPart = {
      partnum: partNumber,
      binCount: 1,
      dmsCount: 0,
      scanCount: count,
      currentCount: 0,
      bins: [
        {
          primaryPartnum: partNumber,
          binName: bin,
          binType: 'primary',
          scanCount: count,
          currentCount: 0,
          assignedUser: '--',
          inputUser: '--',
          id: `${partNumber}-${bin}`,
        },
      ],
    }

    props.onCountUpdate?.(props.order.id, 1);
    setParts([newPart, ...parts]);
    window.location.reload()
  }

  const getExistingBinsForPart = (partnum) => {
    if (!partnum) return []
    const part = parts.find(p => p.partnum === partnum)
    return part ? part.bins.map(b => b.binName) : []
  }

  const addItem = async (data, isSecondary) => {
    const guard = validateAddBin({
      ...data,
      existingBins: isSecondary ? getExistingBinsForPart(data.partNumber) : [],
    })
    if (!guard.ok) {
      setAddItemError(guard.error)
      return
    }

    setAddItemModalButtonDisabled(true)
    try {
      if (isSecondary) {
        await addSecondaryBin(data)
      } else {
        await addPrimaryBin(data)
      }
      setAddItemModal(null)
    } catch (e) {
      console.error(e)
      setAddItemError('Incorrect data')
    } finally {
      setAddItemModalButtonDisabled(false)
    }
  }

  const deletePrimary = partnum => {
    props.onCountUpdate?.(props.order.id, -1)
    setParts(parts.filter((part => part.partnum !== partnum)))
  }

  const deleteSecondary = (partnum, bin) => {
    const newParts = parts.map(part => {
      if (part.partnum === partnum) {
        return {
          ...part,
          scanCount: part.scanCount - bin.scanCount,
          currentCount: part.currentCount - bin.currentCount,
          binCount: --part.binCount,
          bins: part.bins.filter(partBin => partBin.binName !== bin.binName),
        }
      } else {
        return part
      }
    })

    setParts(newParts)
  }

  const deleteItem = async (item) => {
    setActionsDisabled(true)
    if (item.binType === 'secondary') {
      await deleteSecondaryBin(props.order.id, item.primaryPartnum, item.binName)
      deleteSecondary(item.primaryPartnum, item)
    } else {
      await deletePartnum(props.order.id, item.primaryPartnum)
      deletePrimary(item.primaryPartnum)
    }
    setActionsDisabled(false)
  }

  const setNewPrimaryBin = (partnum, bin) => {
    const newParts = parts.map(part => {
      if (part.partnum === partnum) {
        let newPrimaryBin
        const secondaryBins = []
        part.bins.forEach(partBin => {
          if (partBin.binName === bin) {
            newPrimaryBin = { ...partBin, binType: 'primary' }
          } else {
            secondaryBins.push({ ...partBin, binType: 'secondary' })
          }
        })
        return {
          ...part,
          bins: [newPrimaryBin, ...secondaryBins],
        }
      } else {
        return part
      }
    })

    setParts(newParts)
  }

  const onSelectBinType = async (bin) => {
    setActionsDisabled(true)
    try {
      await updatePrimaryBin(props.order.id, bin.primaryPartnum, bin.binName)
      setNewPrimaryBin(bin.primaryPartnum, bin.binName)
    } catch (error) {
      console.error('Not updated')
    }
    setActionsDisabled(false)
  }


  const sortTable = ({ dataKey }) => {
    if (dataKey !== 'selectAll') {
      setPartsSort({
        isDesc: partsSort.prop === dataKey ? !partsSort.isDesc : false,
        prop: dataKey,
      })
    } else {
      const newCheckedRows = { ...checkedRows };
      const data = countingMode === 'Parts' ? parts : tableBins;
      const isCurrentlyChecked = data.length === Object.keys(checkedRows).length && Object.keys(checkedRows).length > 0;
      const filteredData = data.filter(data => data.unitPrice > props.value);

      if (!isCurrentlyChecked) {
        filteredData.forEach(el => {
          newCheckedRows[el.partnum] = true;
        })
        setCheckedRows({ ...newCheckedRows });
      } else {
        setCheckedRows({});
      }
    }
  }

  const updateCurrentCount = async ({ partnum, bin, count }) => {
    setUpdateCurrentCountModalButtonDisabled(true)
    try {
      await updateSecondCount(props.order.id, partnum, bin, count);
      const newParts = parts.map(part => {
        if (part.partnum === partnum) {
          let countDiff = 0
          return {
            ...part,
            bins: part.bins.map(oldBin => {
              if (oldBin.binName === bin) {
                countDiff = count - oldBin.currentCount
                return {
                  ...oldBin,
                  currentCount: +count,
                }
              } else {
                return oldBin
              }
            }),
            currentCount: part.currentCount + countDiff,
          }
        } else {
          return part
        }
      })

      setUpdateCurrentCountModal(null)
      setUpdateCurrentCountModalButtonDisabled(false)
      setParts(newParts);
      setNotNullablePartsBins(prevState => {
        return [...prevState, partnum, bin]
      })

    } catch (error) {
      setUpdateCurrentCountError('Something went wrong')
    }
  }

  const isAnyActionsDisabled = () => {
    const status = props.order.status;

    return (
      status === 'canceled' ||
      status === 'aborted' ||
      status === 'completed' ||
      props.completed
    )
  }

  useEffect(() => {
    const { prop, isDesc } = partsSort
    const sorted = [...parts].sort(sortText(prop, isDesc))
    setParts(sorted)
  }, [partsSort]);

  const handleValue = useCallback((value) => {
    switch (value) {
      case 'Accepted only': return 'accepted';
      case 'Active only': return 'active';
      case 'DMS == Current': return 'dms_match'; // Add this line
      default: return value; // Good practice to have a default
    }
  }, [])


  useEffect(() => {
    const { statusFilterList, parts: reduxParts } = props;

    if (reduxParts.data) {
      const filtered = convertPartnumData(reduxParts, props.employeeMap).filter(part => {
        let isValid = true;

        statusFilterList.getSet().forEach(filter => {
          const mappedValue = handleValue(filter.value);

          // Special logic for our comparison filter
          if (mappedValue === 'dms_match') {
            // In convertPartnumData, overallCountOnFile is mapped to dmsCount
            // and the total count is mapped to currentCount
            if (part.dmsCount !== part.currentCount) {
              isValid = false;
            }
          }
          // Standard logic for 'active' or 'accepted'
          else if (part[filter.prop] !== mappedValue) {
            isValid = false;
          }
        });

        return isValid;
      });

      setParts(filtered);
    }
  }, [props.statusFilterList, setParts, props.parts, handleValue]); // Added handleValue to dependencies

  useEffect(() => {
    const filteredArray = parts.filter(part => part.status === 'accepted');
    setAcceptedParts(filteredArray);
  }, [parts, props.setAcceptedPartsRedux]);


  const options = () => {
    return {
      columns: [
        {
          name: '',
          type: 'text',
        },

        {
          name: 'Bin',
          type: 'text',
          isSortable: true,
          dataKey: 'binName',
        },
        {
          name: 'Parts',
          type: 'text',
          isSortable: true,
          dataKey: 'parts.length',
        },
        {
          name: 'DMS Count',
          type: 'text',
          isSortable: true,
          dataKey: 'dmsCount',
        },
        {
          name: 'Scan Count',
          type: 'text',
          flexGrow: 'fg100-c',
          dataKey: 'scanCount',
          isSortable: true,
        },
        {
          name: 'Unit Price',
          type: '--',
        },
        {
          name: 'Current Count',
          type: 'component',
          component: cloneElement(<CurentCountBins />, {
            actives: notNullablePartsBins
          }),
          isSortable: true,
          dataKey: 'currentCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Assigned User',
          type: '--',
        },
        {
          name: 'Input User',
          type: 'text',
          dataKey: 'inputUser',
        },
        {
          name: 'Status',
          type: '--',
        },
      ],
      childrenKey: 'parts',
      childrenColumns: [
        {
          name: '',
          type: 'blank',
        },
        {
          name: 'Part',
          type: 'blank',
        },
        {
          name: 'Bin',
          type: 'component',
          component: cloneElement(<PartNameDeletable />, {
            onClick: deleteItem,
            disabled: isAnyActionsDisabled(),
          }),
        },
        {
          name: 'DMS Count',
          type: 'text',
          dataKey: 'dmsCount',
        },
        {
          name: 'Scan Count',
          type: 'text',
          dataKey: 'scanCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Unit Price',
          type: 'number',
          dataKey: 'unitPrice',
        },
        {
          name: 'Current Count',
          flexGrow: 'fg100-c',
          type: 'component',
          component: cloneElement(<CurrentCountEditable />, {
            onClick: setUpdateCurrentCountModal,
            disabled: isAnyActionsDisabled(),
            countingMode: countingMode,
            acceptedParts: acceptedParts,
            onClickForCount: setNotNullablePartsBins,
            isActive: notNullablePartsBins,
            parts: parts
          }),
        },
        {
          name: 'Assigned User',
          type: 'text',
          dataKey: 'assignedUser',
        },
        {
          name: 'Input User',
          type: '--',
        },
        {
          name: 'Status',
          type: 'text',
          dataKey: 'status',
        },
      ],
    }
  }

  const selectUsers = useCallback(() => {
    const data = countingMode === 'Parts' ? parts : tableBins;
    return data.length === Object.keys(checkedRows).length && Object.keys(checkedRows).length > 0 ? 'Unselect all' : 'Select all';
  }, [checkedRows]);

  const getTableOptions = (countingMode) => {
    return {
      columns: [
        {
          name: selectUsers(),
          type: 'checkbox',
          dataKey: 'selectAll',

        },
        ...(countingMode === 'Parts' ? [
          {
            name: 'Part',
            type: 'text',
            isSortable: true,
            dataKey: 'partnum',
          },
          {
            name: 'Bin',
            type: 'text',
            isSortable: true,
            dataKey: 'binCount',
          },
          {
            name: 'Bin Type',
            type: 'component',
            component: cloneElement(<AddNewBinButton />, {
              onClick: setAddItemModal,
              disabled: isAnyActionsDisabled(),
            }),
            dataKey: 'binCount',
          },
        ] : [
          {
            name: 'Bin',
            type: 'text',
            dataKey: 'primaryBin',
          },
          {
            name: 'Part',
            type: 'text',
            isSortable: true,
            dataKey: 'binCount',
          },
          {
            name: '',
            type: 'blank',
          },
        ]),

        {
          name: 'DMS Count',
          type: 'text',
          isSortable: true,
          dataKey: 'dmsCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Scan Count',
          type: 'text',
          isSortable: true,
          dataKey: 'scanCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Price Each',
          type: 'number',
          isSortable: true,
          dataKey: 'unitPrice',
          flexGrow: 'fg100-c',
        },

        {
          name: 'Current Count',
          type: 'component',
          component: cloneElement(<CurrentCount />),
          isSortable: true,
          dataKey: 'currentCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Assigned User',
          type: 'text',           // Changed from '--' to 'text'
          dataKey: 'assignedUser', // Added dataKey
        },
        {
          name: 'Input User',
          type: 'text',           // Changed from '--' to 'text'
          dataKey: 'inputUser',    // Added dataKey
        },
        {
          name: 'Status',
          type: 'text',
          dataKey: 'status',
        },
      ],

      childrenKey: 'bins',
      childrenColumns: [
        {
          name: 'Select',
          type: '',
        },
        {
          name: 'Part',
          type: 'blank',
        },
        ...(countingMode === 'Parts' ? [

          {
            name: 'Bin',
            type: 'component',
            component: cloneElement(<BinNameDeletable />, {
              onClick: deleteItem,
              disabled: isAnyActionsDisabled(),
              acceptedParts: acceptedParts
            }),
          },
          {
            name: 'Bin Type',
            type: 'select',
            dataKey: 'binType',
            options: [
              'primary',
            ],
            onSelect: onSelectBinType,
            disabled: status => status === 'primary' || isAnyActionsDisabled(),
          },
        ] : [{
          name: 'Part',
          type: 'component',
          component: cloneElement(<BinNameDeletable />, {
            onClick: deleteItem,
            disabled: isAnyActionsDisabled(),
            part: true,
          }),

        },
        {
          name: '--',
          type: 'blank',
        }]),
        {
          name: 'DMS Count',
          type: '--',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Scan Count',
          type: 'text',
          dataKey: 'scanCount',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Price Each',
          type: '--',
          flexGrow: 'fg100-c',
        },
        {
          name: 'Current Count',
          flexGrow: 'fg100-c',
          type: 'component',
          component: cloneElement(<CurrentCountEditable />, {
            onClick: setUpdateCurrentCountModal,
            disabled: isAnyActionsDisabled(),
            countingMode: countingMode,
            acceptedParts: acceptedParts,
            onClickForCount: setNotNullablePartsBins,
            isActive: notNullablePartsBins,
            parts: parts
          }),
        },
        {
          name: 'Assigned User',
          type: 'text',
          dataKey: 'assignedUser',
        },
        {
          name: 'Input User',
          type: 'text',
          dataKey: 'inputUser',
        },
        {
          name: 'Status',
          type: '--',
          dataKey: 'inputUser',
        },
      ],

    }
  }


  const tableOptions = getTableOptions(countingMode);

  const handleSlash = useCallback((str) => str.split('-').join(''), []);

  const handleCompleteVarianceRun = useCallback(async () => {
    if (!window.confirm("Mark this variance run as completed? This will unlock the next waterfall step.")) {
      return;
    }

    try {
      setActionsDisabled(true);

      const currentRunId = props.order?.id;
      if (!currentRunId) {
        alert("No variance run found to complete.");
        return;
      }

      // 1) Update backend status for THIS run
      await updateVarianceCheckingStatus(currentRunId, "completed");

      // 2) Refresh orders so VarianceProgress flips the UI immediately
      if (typeof props.refreshOrders === "function") {
        await props.refreshOrders();
      }

      // 3) If backend creates/updates asynchronously, optionally wait for the next run
      // (safe no-op if not provided)
      const prevLastRunId = props.orders?.[props.orders.length - 1]?.id;
      if (typeof props.waitForNewRun === "function" && prevLastRunId) {
        await props.waitForNewRun(prevLastRunId);
      }

      // 4) Refresh variance bins/users
      if (typeof props.refreshVariance === "function") {
        await props.refreshVariance();
      }
    } catch (e) {
      console.error("Complete run failed:", e);
      alert("Failed to complete run. Check console logs.");
    } finally {
      setActionsDisabled(false);
    }
  }, [props.order, props.refreshOrders, props.refreshVariance, props.waitForNewRun, props.orders]);

  const onSearch = useCallback(async (data) => {
    const { parts: reduxParts } = props;

    setParts(convertPartnumData(reduxParts, props.employeeMap).filter(part => {
      return handleSlash(part.partnum.toUpperCase()).includes(handleSlash(data.toUpperCase()));
    }))

  }, [setParts, parts]);

  const onClear = useCallback(async () => {
    setSearchFilter('');
    const { data } = await getPartnumData(props.order.id)
    setParts(convertPartnumData(data, props.employeeMap));
  }, [setSearchFilter, setParts, getPartnumData])

  return (
    <div className="order-info">
      <OrderInfoHeader
        className="order-info__header"
        order={props.order}
        onAddPart={() => setAddItemModal({ type: 'part' })}
        onSearch={onSearch}
        onClear={onClear}
        onCompleteRun={handleCompleteVarianceRun}  // <-- ADD THIS
        onSort={sortTable}
        countingModeInfo={{ countingMode, setCountingMode }}
        options={tableOptions}
        data={filteredParts ? filteredParts : parts}
      />
      <BaseTable
        className="order-info__table"
        order={props.order}
        keyProp='partnum'
        onSort={sortTable}
        options={countingMode === 'Parts' ? tableOptions : options()}
        data={countingMode === 'Parts' ? parts : tableBins}
        foldable={true}
        padding="3.6rem"
        button={{ checked, isChecked }}
        countingMode={countingMode}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
      />
      {addItemModal &&
        <AddNewBinPartModal
          onClose={() => {
            setAddItemModal(null)
            setAddItemError('')
          }}
          type={addItemModal.type}
          partnum={addItemModal.partnum}
          existingBins={getExistingBinsForPart(addItemModal.partnum)}
          onAdd={addItem}
          modalError={addItemError}
          removeError={() => setAddItemError('')}
          disabled={addItemModalButtonDisabled}
        />
      }
      {updateCurrentCountModal &&
        <UpdateCurrentCountModal
          onClose={() => {
            setUpdateCurrentCountModal(null)
            setUpdateCurrentCountError('');
          }}
          bin={updateCurrentCountModal}
          onUpdate={updateCurrentCount}
          modalError={updateCurrentCountError}
          removeError={() => setUpdateCurrentCountError('')}
          disabled={updateCurrentCountModalButtonDisabled}
          countingMode={countingMode}
        />
      }
      {actionsDisabled &&
        <div className="order-info__disabled"></div>
      }
    </div>
  )
}

const mapStateToProps = (
  { employees: { employeeMap },
    data: {
      render,
      value, orders, newRun, statusFilterList, parts, priceFilterValue, completed } }) => ({
        employeeMap,
        render,
        value,
        orders,
        newRun,
        statusFilterList,
        priceFilterValue,
        parts,
        completed
      })
const mapDispatchToProps = ({ fetchPrintData, getPartsAction })

export default connect(mapStateToProps, mapDispatchToProps)(OrderInfo)
